import { createContext } from "react";

const ThemeContext = createContext(["#ad343e", () => {}]);

export default ThemeContext;
